import Toggle from "../../util/toggle";

function Selectblock() {

    if (document.querySelector('.selectblock') !== null) {
        this.init();
    }

}

Selectblock.prototype.init = function() {

    var toggle = new Toggle('.selectblock__header','.selectblock ul','clicked','show',false,true),
    selectBlocks = document.querySelectorAll('.selectblock.js'),
    selectBlock;

    if (selectBlocks !== null) {
        for (var i=0; i < selectBlocks.length; i++) {
            selectBlock = selectBlocks[i];
            this.list_width(selectBlock);
        }
    }

}

Selectblock.prototype.list_width = function(elem) {
    
    // get width of widest list item and set parent to that width

    if (window.innerWidth >= 600) {
        
        var lists = elem.querySelectorAll('ul li'),
            list,
            biggestWidth;

        if (lists !== null) {
            biggestWidth = 0;
            for (var i=0;i<lists.length;i++) {

                list = lists[i];
                if (list.offsetWidth > biggestWidth) {
                    biggestWidth = list.offsetWidth;
                }
            }
            elem.style.width = biggestWidth+"px";

        }

    }
}

export default Selectblock;


// WEBPACK FOOTER //
// ./js/components/selectblock/index.js